import { BookFromPreviousOrderModule } from '@aca-new/app/pages/bookings/pages/previous-order-item/components/book-from-previous-order/book-from-previous-order.module';
import { PreviousOrderItemComponent } from '@aca-new/app/pages/bookings/pages/previous-order-item/previous-order-item.component';
import { AuditsTableStrategyService } from '@aca-new/app/pages/bookings/pages/previous-order-item/shared/services/table-stratetgy/audits-table-strategy.service';
import { FoodCertificationTableStrategyService } from '@aca-new/app/pages/bookings/pages/previous-order-item/shared/services/table-stratetgy/food-certification-table-strategy.service';
import { InspectionTableStrategyService } from '@aca-new/app/pages/bookings/pages/previous-order-item/shared/services/table-stratetgy/inspection-table-strategy.service';
import { LabTestingTableStrategyService } from '@aca-new/app/pages/bookings/pages/previous-order-item/shared/services/table-stratetgy/lab-testing-table-strategy.service';
import { TableStrategyFactoryService } from '@aca-new/app/pages/bookings/pages/previous-order-item/shared/services/table-stratetgy/table-strategy-factory.service';
import { TrackByUuidDirective } from '@aca-new/app/shared/directives/track-by-uuid.directive';
import { AppServiceTypeFullNameModule } from '@aca-new/app/shared/pipes/service-type-full-name/service-type-full-name.module';
import { ServiceTypeIceCubeStyleModule } from '@aca-new/app/shared/pipes/service-type-ice-cube-style/service-type-ice-cube-style.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { QimaAutoTooltipDirectiveModule, QimaButtonModule, QimaIceCubeModule, QimaSpinnerModule, QimaTooltipDirectiveModule } from '@qima/ngx-qima';

@NgModule({
  declarations: [PreviousOrderItemComponent],
  imports: [
    CommonModule,
    TranslateModule,
    QimaIceCubeModule,
    ServiceTypeIceCubeStyleModule,
    QimaTooltipDirectiveModule,
    QimaSpinnerModule,
    QimaAutoTooltipDirectiveModule,
    BookFromPreviousOrderModule,
    AppServiceTypeFullNameModule,
    TrackByUuidDirective,
    QimaButtonModule,
  ],
  exports: [PreviousOrderItemComponent],
  providers: [FoodCertificationTableStrategyService, InspectionTableStrategyService, LabTestingTableStrategyService, AuditsTableStrategyService, TableStrategyFactoryService],
})
export class PreviousOrderItemModule {}
